import { Vue, Component, Watch } from 'vue-property-decorator'
import { message } from 'ant-design-vue'
import { Modal } from 'ant-design-vue'
const ignoreCodes = { 401: 1, 403: 1 }

/**
 * 本系统所有页面、组件的基类
 */
@Component
export default class ViewBase extends Vue {
  [x: string]: any

  get newlan() {
    return this.$store.state.setting.en
  }

  @Watch('newlan')
  watchNewlan(val: any) {
    this.setlan()
  }
}
